export default __webpack_public_path__ + "static/media/093-turn-left-1.e445ae5f.png";